import { pushToDataLayer } from "../pushToDatalayer";

/**
 * Track events on the checkout page. These include:
 * - Submit checkout
 * - Cancel checkout
 *
 * @returns {void}
 */
function initCheckoutTracking() {
  // Exit if were not on the checkout page
  if (!document.querySelector(".checkout")) return;

  // Track submit checkout
  document
    .querySelector(".checkout__submit-btn")
    .addEventListener("click", () => {
      pushToDataLayer("checkout", {
        eventCategory: "checkout",
        eventAction: "submit",
        eventLabel: "checkout submit",
      });
    });

  // Track cancel checkout
  document.querySelector(".checkout__cancel").addEventListener("click", () => {
    pushToDataLayer("checkout", {
      eventCategory: "checkout",
      eventAction: "cancel",
      eventLabel: "checkout cancel",
    });
  });
}

export default initCheckoutTracking;
